import React, { useMemo } from 'react';
import { EditorDeclarativeBlock } from '@/webapi/use-experience-api';
import { ChangeScreenshot } from '@/utils/change-screenshot';
import { SelectorSection } from '../components/selector-section';
import { SelectorTooltip } from '../components/selector-tooltip';

interface SimpleActionTitleProps {
  prefix: string;
  change: EditorDeclarativeBlock;
  screenshot: ChangeScreenshot;
}

export function SimpleActionTitle({
  prefix,
  change,
  screenshot,
}: SimpleActionTitleProps) {
  const changeTooltipId = useMemo(() => `change-${change.editorId}`, [change]);
  const { editorId, hint } = change;
  return (
    <>
      {!!hint && (
        <>
          <span data-tip data-for={changeTooltipId}>
            {hint}
          </span>
          <SelectorTooltip
            id={changeTooltipId}
            selector={`${prefix} ${change.editorSelector}`}
            image={screenshot.changeUrl}
          />
        </>
      )}
      {!hint && (
        <>
          {prefix}:{` `}
          <SelectorSection
            image={screenshot.mountUrl}
            editorId={editorId}
            selector={change.editorSelector}
          />
        </>
      )}
    </>
  );
}
